// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"1c87437c","977":"43bfdb57"}[chunkId] + ".chunk.js";
};